// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SwatchSelect{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:0;margin-right:-4px;margin-left:-4px;}@media (max-width: 799px){.SwatchSelect{flex-wrap:wrap}}.SwatchSelect__slot{padding:4px;flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
